module.exports = __webpack_public_path__ + "img/project2.77855519.png";